import React from "react";

const DataContainer = ({ children }) => (
  <div className="flex items-center">{children}</div>
);

export default DataContainer;
